import React, { FC } from 'react';
import { AuthenticationContainer } from '@components/organisms/AuthenticationContainer';
import { CreateAccountCard } from '@components/molecules/authentication/CreateAccountCard';

export const CreateAccount: FC = () => {
    return (
        <AuthenticationContainer>
            <CreateAccountCard />
        </AuthenticationContainer>
    );
};
